/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  FertilityReproductiveHealthResponseDto,
  FertilityReproductiveHealthUpsertRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    FertilityReproductiveHealthResponseDtoFromJSON,
    FertilityReproductiveHealthResponseDtoToJSON,
    FertilityReproductiveHealthUpsertRequestDtoFromJSON,
    FertilityReproductiveHealthUpsertRequestDtoToJSON,
} from '../models/index';

export interface GetFertilityReproductiveHealthByPatientIdRequest {
    patientId: string;
}

export interface UpsertFertilityReproductiveHealthRequest {
    fertilityReproductiveHealthUpsertRequestDto: FertilityReproductiveHealthUpsertRequestDto;
}

export interface UpsertFertilityReproductiveHealthByPatientIdRequest {
    patientId: string;
    fertilityReproductiveHealthUpsertRequestDto: FertilityReproductiveHealthUpsertRequestDto;
}

/**
 * 
 */
export class PatientFertilityReproductiveHealthApi extends runtime.BaseAPI {

    /**
     * Get patient\'s fertility & reproductive health intake
     */
    async getFertilityReproductiveHealthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FertilityReproductiveHealthResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/fertility-reproductive-health`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FertilityReproductiveHealthResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s fertility & reproductive health intake
     */
    async getFertilityReproductiveHealth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FertilityReproductiveHealthResponseDto> {
        const response = await this.getFertilityReproductiveHealthRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s fertility & reproductive health intake by patient ID
     */
    async getFertilityReproductiveHealthByPatientIdRaw(requestParameters: GetFertilityReproductiveHealthByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FertilityReproductiveHealthResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getFertilityReproductiveHealthByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/fertility-reproductive-health/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FertilityReproductiveHealthResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s fertility & reproductive health intake by patient ID
     */
    async getFertilityReproductiveHealthByPatientId(requestParameters: GetFertilityReproductiveHealthByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FertilityReproductiveHealthResponseDto> {
        const response = await this.getFertilityReproductiveHealthByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create/update patient\'s fertility & reproductive health intake
     */
    async upsertFertilityReproductiveHealthRaw(requestParameters: UpsertFertilityReproductiveHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FertilityReproductiveHealthResponseDto>> {
        if (requestParameters['fertilityReproductiveHealthUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'fertilityReproductiveHealthUpsertRequestDto',
                'Required parameter "fertilityReproductiveHealthUpsertRequestDto" was null or undefined when calling upsertFertilityReproductiveHealth().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/fertility-reproductive-health`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FertilityReproductiveHealthUpsertRequestDtoToJSON(requestParameters['fertilityReproductiveHealthUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FertilityReproductiveHealthResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create/update patient\'s fertility & reproductive health intake
     */
    async upsertFertilityReproductiveHealth(requestParameters: UpsertFertilityReproductiveHealthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FertilityReproductiveHealthResponseDto> {
        const response = await this.upsertFertilityReproductiveHealthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create/update patient\'s fertility & reproductive health intake by patient ID
     */
    async upsertFertilityReproductiveHealthByPatientIdRaw(requestParameters: UpsertFertilityReproductiveHealthByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FertilityReproductiveHealthResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertFertilityReproductiveHealthByPatientId().'
            );
        }

        if (requestParameters['fertilityReproductiveHealthUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'fertilityReproductiveHealthUpsertRequestDto',
                'Required parameter "fertilityReproductiveHealthUpsertRequestDto" was null or undefined when calling upsertFertilityReproductiveHealthByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/fertility-reproductive-health/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FertilityReproductiveHealthUpsertRequestDtoToJSON(requestParameters['fertilityReproductiveHealthUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FertilityReproductiveHealthResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create/update patient\'s fertility & reproductive health intake by patient ID
     */
    async upsertFertilityReproductiveHealthByPatientId(requestParameters: UpsertFertilityReproductiveHealthByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FertilityReproductiveHealthResponseDto> {
        const response = await this.upsertFertilityReproductiveHealthByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
